import Markdown from 'react-markdown';
import { BCMarkdownProps } from './entities';

export default ({ content }: BCMarkdownProps) => {
	return <Markdown>{content}</Markdown>;
};
